import React, { useEffect } from 'react'
import { useMutation } from '@apollo/client'
import { FormProvider, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as Yup from 'yup'
import { toastSweetAlert } from '../../../Helpers/ToastSweetAlert'
import Box from '../../../Global/Box'
import InputController from '../../../Global/InputController'
import { GET_ALL_CONFIG_APP_PAGES } from '../../../../graphql/ConfigApp/configAppPages'
import {
  CREATE_OR_UPDATE_ELEMENT_HeaderText,
  GET_ALL_ELEMENTS_OF_CONFIG_APP_PAGE,
} from '../../../../graphql/ConfigApp/configAppPageElements'

const refetchConfigsAppPage = {
  query: GET_ALL_CONFIG_APP_PAGES,
  variables: {
    limit: 10,
    offset: 0,
    searchQuery: null,
  },
}

const optionsAlingText = [
  { value: 'left', label: 'Izquierda' },
  { value: 'center', label: 'Center' },
  { value: 'right', label: 'Derecha' },
]

const HeaderText = ({ pageId, dataElement, setDataElement }) => {
  //MUTATIONS:
  const [createOrUpdate] = useMutation(CREATE_OR_UPDATE_ELEMENT_HeaderText)

  //FORM:
  const validationSchema = Yup.object().shape({
    alingText: Yup.string().required('Campo requerido'),
    fontSize: Yup.string().required('Campo requerido'),
    text_es: Yup.string().required('Campo requerido'),
  })

  const {
    methods,
    handleSubmit,
    formState: { errors },
    control,
    reset,
  } = useForm({
    resolver: yupResolver(validationSchema),
  })

  const handleCancel = () => setDataElement(null)

  const onSubmit = async (dataForm) => {
    try {
      let message = ''

      if (dataElement?.id) {
        //Es actualizacion
        const variables = {
          inputGeneral: {
            id: dataElement.id,
            config_app_page_id: dataElement.config_app_page_id,
            order: dataElement.order,
            layout: dataElement.layout,
          },
          inputElement: {
            alingText: dataForm.alingText,
            fontSize: parseInt(dataForm.fontSize),
            text: {
              es: dataForm.text_es,
              en: dataForm.text_en,
            },
          },
        }
        await createOrUpdate({
          variables,
          refetchQueries: [
            {
              query: GET_ALL_ELEMENTS_OF_CONFIG_APP_PAGE,
              variables: { configAppPageId: pageId },
            },
          ],
        })
        message = 'Se actualizo correctamente'
      } else {
        //Es nuevo
        const variables = {
          inputGeneral: {
            id: null,
            config_app_page_id: dataElement.config_app_page_id,
            order: null,
            layout: dataElement.layout,
          },
          inputElement: {
            alingText: dataForm.alingText,
            fontSize: parseInt(dataForm.fontSize),
            text: {
              es: dataForm.text_es,
              en: dataForm.text_en,
            },
          },
        }
        await createOrUpdate({
          variables,
          refetchQueries: [
            { ...refetchConfigsAppPage },
            {
              query: GET_ALL_ELEMENTS_OF_CONFIG_APP_PAGE,
              variables: { configAppPageId: pageId },
            },
          ],
        })
        message = 'Se creo con exito'
      }

      setDataElement(null)

      return toastSweetAlert({ mode: 'ok', message })
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }

  useEffect(() => {
    if (dataElement?.id) {
      const data = dataElement
      const dataFormated = {
        alingText: data.itemMain.alingText,
        fontSize: data.itemMain.fontSize,
        text_es: data.itemMain.text.es,
        text_en: data.itemMain.text.en,
      }
      reset(dataFormated)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataElement])

  return (
    <>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Box
            withCard={false}
            title="Elemento"
            btnSecondFunctionTitle="Cancelar"
            btnSubmitText={`${dataElement?.id ? 'Actualizar' : 'Crear'}`}
            btnSecondFunction={() => handleCancel()}
            errors={errors}
            btnSubmit={true}
            content={
              <>
                <div className="row">
                  <div className="mb-3 col-12 col-sm-4 col-md-4">
                    <InputController
                      label="Alineación texto"
                      name="alingText"
                      control={control}
                      inputType="choosen"
                      options={optionsAlingText}
                      placeholderTxt="Elige uno"
                      isClearable={true}
                    />
                  </div>
                  <div className="mb-3 col-12 col-sm-4 col-md-4">
                    <InputController
                      label="Tamaño texto"
                      name="fontSize"
                      inputType="number"
                      placeholderTxt="Escribe tamaño"
                      control={control}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <Box
                      title="Texto"
                      content={
                        <>
                          <div className="col-12 mb-3">
                            <InputController
                              label="Español"
                              name="text_es"
                              type="text"
                              placeholderTxt="Escribe texto español"
                              control={control}
                            />
                          </div>
                          <div className="col-12 mb-3">
                            <InputController
                              label="Ingles"
                              name="text_en"
                              type="text"
                              placeholderTxt="Escribe texto ingles"
                              control={control}
                            />
                          </div>
                        </>
                      }
                    />
                  </div>
                </div>
              </>
            }
          />
        </form>
      </FormProvider>
    </>
  )
}

export default HeaderText
